<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <schedule-edit-form
        @on-submit="onScheduleEditSubmit"
      ></schedule-edit-form>
    </div>
  </div>
</template>
<script>
import ScheduleEditForm from "./ScheduleEditForm.vue";

export default {
  components: {
    ScheduleEditForm
  },
  data() {
    return {
      scheduleEditModel: {}
    };
  },
  methods: {
    onScheduleEditSubmit(model) {
      this.scheduleEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'schedules/' + this.scheduleEditModel.id, Object.assign(this.scheduleEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
